module.controller('selectAccountCtrl', [
  '$scope', '$state', '$q', '$stateParams', 'Session', '$http', 'baseURI', 'Transform', 'bankToAddService', 'bankLoginService', 'accountService', 'cacheService',
  function($scope, $state, $q, $stateParams, Session, $http, baseURI, Transform, bankToAddService, bankLoginService, accountService, cacheService) {

    document.documentElement.scrollTop = document.body.scrollTop = 0;

    $scope.cancel = true;
    $scope.getStarted = true;
    $scope.attempted = bankLoginService.attempted;
    $scope.showNext = bankLoginService.showNext;
    var finicityUrlLoading = 'idle';
    var finicityConnectUrl;
    var Connect = window.Connect;

    function handleSuccess() {
      cacheService.clear('bank');
      getCurrentBanks().then(function(currentBanks) {
        var hasNewBank = false;
        angular.forEach(currentBanks, function(newBank) {
          var idx = banks.findIndex(function(oldBank) {
            return oldBank.Id === newBank.Id;
          });
          if (idx < 0) {
            hasNewBank = true;
          }
        });

        if (hasNewBank) {
          $state.go('member.home.bank/add.success', { redirect: $stateParams.redirect });
        } else {
          console.log('No new bank added');
          $scope.finicityAlert = true;
          $scope.finicityMessage = 'We have detected a problem with adding your bank account. Please try again later or contact our support if the problem persists.';
        }
      });
    }

    var connectEventHandlers = {
      onDone: function(event) {
        handleSuccess();
      },
      onCancel: function(event) {
        cacheService.clear('bank');
      },
      onError: function(event) {
        Rollbar.error('Finicity Connect Error:', event);
      },
      onRoute: function(event) {},
      onLoad: function() {}
    };

    var connectOptions = {
      overlay: 'rgba(199,201,199, 0.5)'
    };

    var getCurrentBanks = function() {
      return $q(function(resolve) {
        $http.get(baseURI + 'bank?Username=' + encodeURIComponent($stateParams.username), { cache: true }).then(function(resp) {
          resolve(resp.data.Data || []);
        });
      });
    };

    var banks = [];

    getCurrentBanks().then(function(currentBanks) {
      banks = currentBanks;
    });

    $scope.respSuccess = false;

    accountService.initializeAccounts(function(err, accounts) {
      if (err) {
        console.error(err);
        return;
      }
      var account = accounts[0];
      if (finicityConnectUrl !== 'undefined' && !!account && finicityUrlLoading === 'idle') {
        finicityUrlLoading = 'pending';
        $http({
          url: baseURI + 'bank/verification/url',
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          data: Transform.encode({
            'Username': Session.getUsername(),
            'Redirect': window.location.origin
          })
        }).then(function(resp) {
          finicityConnectUrl = resp.data.Data.BankVerificationLink;
          $scope.respSuccess = true;
        }).catch(function(err) {
          $scope.showFooterError = true;
          Rollbar.error(err);
        });
      }
    });

    $scope.open = function() {
      if (!finicityConnectUrl) {
        console.error('Finicity Connect URL is not available');
        $scope.showFooterError = true;
        return;
      }
      if ($scope.respSuccess) {
        Connect.launch(finicityConnectUrl, connectEventHandlers, connectOptions);
      }
    };
  }
]);
